import { useRef } from 'react';
import cn from 'classnames';
import { DatePickerProps } from './datePicker.props';
import styles from './datePicker.module.scss';
import { Portal } from 'components/other/portal/Portal';
import { Dropdown } from 'components/layout/dropdown/Dropdown';
import { Calendar } from './calendar/Calendar';

export const DatePicker = ({
  name,
  isOpen,
  onClick,
  onOutsideClick,
  onDayClick,
  value,
  disabledDaysBefore,
  disabledDaysAfter,
  className,
}: DatePickerProps): JSX.Element => {
  const faceRef = useRef<HTMLDivElement>(null);

  const moduleStyles = cn(styles.module, className);

  return (
    <>
      <div className={moduleStyles} ref={faceRef} onClick={onClick}>
        <span className={styles.name}>{name}</span>
        <span className={styles.value}>
          {value && new Date(value).toLocaleDateString()}
        </span>
      </div>
      {isOpen && (
        <Portal>
          <Dropdown
            faceRef={faceRef}
            onOutsideClick={onOutsideClick}
            position="bottomLeft"
          >
            <Calendar
              onDayClick={onDayClick}
              disabledDaysBefore={disabledDaysBefore}
              disabledDaysAfter={disabledDaysAfter}
            />
          </Dropdown>
        </Portal>
      )}
    </>
  );
};
